import React from "react";
import { Modal } from "react-bootstrap";

import styles from "./stackableDialog.module.scss";

const StackableDialog = ({ children, onBackdropClick, ...props }) => {
	return (
		<>
			<div className={styles.backdrop} onClick={onBackdropClick} />
			<Modal.Dialog {...props}>{children}</Modal.Dialog>
		</>
	);
};

export default StackableDialog;
